import React, { Component } from 'react';
import apiRequests from './api-helpers/ApiRequests'
import { Container, Row, Col, Modal, Button, Badge } from 'react-bootstrap';
// import AddDictionaryItemDriver from './AddDictionaryItemDriver';
// import EditDictionaryItemDriver from './EditDictionaryItemDriver';

import ModalDrivers from './drivers/ModalDrivers';
import update from 'react-addons-update';

import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next';


class Drivers extends Component {

	constructor(props) {
		super(props);

		this.state = {
			report: new Object(),
			isLoaded: false,
			pageSize: 15,
			currentPageNum: 1,
			totalPagesCount: 1,
			modalItemFormIsVisible: false,
			searchParams: [],
			selectedItem: new Object(),
			dataFromModal: null,
			formType: '',
			showRemoveModal: false,
			selectedOption: null,
		}

		this.loadDriversList = this.loadDriversList.bind(this);
		this.loadDriversListCallback = this.loadDriversListCallback.bind(this);
		this.prevPage = this.prevPage.bind(this);
		this.nextPage = this.nextPage.bind(this);
		this.selectPage = this.selectPage.bind(this);
		this.onClickAddNewItem = this.onClickAddNewItem.bind(this);
		this.onChangeItemFormVisibility = this.onChangeItemFormVisibility.bind(this);
		this.addNewItemCallback = this.addNewItemCallback.bind(this);
		this.searchItems = this.searchItems.bind(this);

		this.editDriver = this.editDriver.bind(this);
		this.editDriverCallback = this.editDriverCallback.bind(this);

		this.removeDriver = this.removeDriver.bind(this);
		this.handleRemoveDriverModal = this.handleRemoveDriverModal.bind(this);
	}

	handleDataFromModal = (data, eventName) => {
		if (data.Message = 'ok') {
			this.setState({ dataFromModal: data, modalItemFormIsVisible: false });
			if( eventName == 'EditDriver') {
	    		this.editDriverCallback(data);
			} else if(eventName == 'AddDriver') {
				this.addDriverCallback(data);
			}
    	}
  	}

  	onChangeItemFormVisibility(value) {
		this.setState({ modalItemFormIsVisible: value });
	}

	////////////////////////////////////////////////
	//
	// Load Drivers
	//
	////////////////////////////////////////////////

	componentDidMount() {
		this.loadDriversList();
	}

	loadDriversList(page) {

		let setPageNum = page ? page : this.state.currentPageNum

		let params = {
			DataInHttpResponse: true,
			SearchParams: [
				...this.state.searchParams,
				{ Name: "page", Value: setPageNum + "" },
				{ Name: "size", Value: this.state.pageSize + "" },
				{ Name: "ExtCompanyId", Value: this.props.userData.CompanyWorkflowId + "X" },
				{ Name: "DId", Value: "0X" }
			],
			ReportID: this.props.t('raportIds.drivers')
		};

		apiRequests.getDataByUrlWithParam('webconapi/GetWebconReport', params, this.loadDriversListCallback);

	}

	loadDriversListCallback(data) {
		
		// Define the indices you want to exclude
		const excludeIndices = [5, 6, 7];

		// Filter out rows at the specified indices
		const filteredColumns = data.columns.filter((_, index) => !excludeIndices.includes(index));

		// Update the report data with the filtered rows
		const filteredData = {
			...data,
			columns: filteredColumns
		};
		let pagesCount = Math.floor(filteredData.count / this.state.pageSize) + 1;

		// Update the state with the filtered data
		this.setState({
			report: filteredData,
			isLoaded: true,
			totalPagesCount: pagesCount,
			currentPageNum: filteredData.page
		});
	}


	////////////////////////////////////////////////
	//
	// Navigation & Search
	//
	////////////////////////////////////////////////
	prevPage() {
		if (this.state.currentPageNum > 1) {
			this.setState((prevState) => ({ isLoaded: false }), () => { this.loadDriversList(this.state.currentPageNum - 1) })
		}
	}

	nextPage() {
		if (this.state.currentPageNum < this.state.totalPagesCount) {
			this.setState((prevState) => ({ isLoaded: false }), () => { this.loadDriversList(this.state.currentPageNum + 1) })
		}
	}

	searchItems(element) {
		let searchParam = { Name: element.target.name, Value: element.target.value };

		this.setState(prevState => {
			const idx = prevState.searchParams.findIndex(obj => obj.Name === searchParam.Name);
			if (idx === -1) {
				return { searchParams: [...prevState.searchParams, searchParam] };
			}
			else {
				return { searchParams: update(prevState.searchParams, { [idx]: { $set: searchParam } }) };
			}

		}, () => { this.loadDriversList(1) });
	}

	onSelectItem(element) {
		this.setState({ selectedItem: element });
	}

	selectPage() {}

	////////////////////////////////////////////////
	//
	// Add Driver
	//
	////////////////////////////////////////////////
	onClickAddNewItem() {
		this.setState({ formType: 'addDriver' });
		this.onChangeItemFormVisibility(true);
	}

	addNewItemCallback() {
		let currentPage = 1;
		this.loadDriversList(currentPage);
	}

	////////////////////////////////////////////////
	//
	// Edit Driver
	//
	////////////////////////////////////////////////
	editDriver() {
		this.setState({ formType: 'editDriver' });
		this.onChangeItemFormVisibility(true);
	}

	editDriverCallback(data, response) {
		if (data.Message) {
			this.setState((prevState) => ({ isLoaded: false, selectedItem: new Object() }), () => { this.loadDriversList(this.state.currentPageNum) })
		}
	}

	////////////////////////////////////////////////
	//
	// Remove Driver
	//
	////////////////////////////////////////////////
	handleRemoveDriverModal() {
		this.setState({ 
			showRemoveModal: !this.state.showRemoveModal,
			hideRemoveModal: !this.state.hideRemoveModal
		});
	}

	removeDriver() {
	

		if( this.state.selectedItem.cells ) {

			let elemId = this.state.selectedItem.cells[0].value;


			if (typeof elemId !== 'undefined') {

				let national = JSON.stringify([{
					"Id": this.state.selectedItem.cells[3].value[0].id, 
					"Name": this.state.selectedItem.cells[3].value[0].name 
				}]);

				let editDriverParams = {
					Id: this.state.selectedItem.id,
					Name: this.state.selectedItem.cells[1].value,
					Surname: this.state.selectedItem.cells[2].value,
					Nationality: national,
					IdDocumentNumber: this.state.selectedItem.cells[4].value,
					Address: '',
					ZipCode: '',
					City: '',
					Phone: this.state.selectedItem.cells[8].value,
					IsActived: 1,
					IsSaved: 1,
					IsCanceled: 1,
					CompanyIdRemoving: this.props.userData.CompanyWorkflowId
				}

				apiRequests.getDataByUrlWithParam('webconapi/EditDriverDictionaryItem', editDriverParams, this.editDriverCallback);

			}

		}

		this.setState({ 
			showRemoveModal: !this.state.showRemoveModal,
			hideRemoveModal: !this.state.hideRemoveModal
		});

	}
		

	////////////////////////////////////////////////
	//
	// Render 
	//
	////////////////////////////////////////////////
	render() {
		let content = !this.state.isLoaded ? (
			<Container className="m-0 p-0">
				<div className="row h-100 m-auto justify-content-center">
					<div className="spinner-border text-primary align-self-center" role="status">
					</div>
				</div>
			</Container>
		) : (
			<>  
				<ModalDrivers 
					formEvent={ this.state.formType }
					showModal={ this.state.modalItemFormIsVisible }
					onChangeEditItemFormVisibilityHandler={ this.onChangeItemFormVisibility }
					addNewEventNotificationCallback={ this.addNewItemCallback }
					userData={ this.props.userData }
					selectedItem={ this.state.selectedItem }
					backToParrentData={ this.handleDataFromModal }
				/>
				<table className="table custom-table-font">
					<thead>
						<tr>
							<th scope="col">#</th>
								{
									this.state.report.columns.map((column) => {
										return (
											<th
												key={column.guid}
												scope="col"
												className={"" + (column.name === "ID" ? "d-none" : "")}
											>
												{column.name}
											</th>
										);
									})
								}
						</tr>
					</thead>
					<tbody>
						<tr key="-1">
							<th scope="row">
								<div className="d-flex flex-column">
									<div className="d-flex flex-grow-1">
										<i className="bi bi-search"></i>
									</div>
								</div>
							</th>
							{ this.state.report.columns.map((column) => {

								let searchParamVal = this.state.searchParams.find(x => x.Name == column.name);

								return (
									<td 
										key={ column.guid ? column.guid : "ColumnKey" + column.name }
										className={ "" + column.name == "ID" ? "d-none" : "" }
									>
										<input 
											type="text"
											className="form-control fs-7"
											id={column.id ? column.id : "IdColumn" + column.name}
											name={column.name}
											placeholder={column.name}
											onChange={this.searchItems}
											value={searchParamVal ? searchParamVal.Value : ""}
										/>
									</td>
								)
							})}
						</tr>
						{ this.state.report.rows.map((row,i) => (
							<tr 
								key={row.id + "_" + i}
								onClick={() => this.onSelectItem(row)}
								className={this.state.selectedItem.id == row.id ? "selectedListItem" : ""}
							>
								<th scope="row">
									{ ((this.state.currentPageNum - 1) * this.state.pageSize) + i + 1 }
								</th>
								{row.cells.map((cell, j) => {
									// Skip cells with indices 5, 6, 7
									if ([5, 6, 7].includes(j)) {
										return null; // Exclude this cell from rendering
									}

									return (
										<td
											key={row.id + "_" + j}
											className={j === 0 ? "d-none" : ""}
										>
											{Array.isArray(cell.value) ? cell.value[0].name : cell.value}
										</td>
									);
								})}


							</tr>
						))}
					</tbody>
				</table>
			</>
		)

		return (
			<>
				<Modal 
					// show={ true }
					size="sm"
					//aria-labelledby="contained-modal-title-vcenter"
					centered
					show={ this.state.showRemoveModal }
					onHide={ this.handleRemoveDriverModal }
				>
					<Modal.Header closeButton>
						<Modal.Title>{this.props.t('drivers.modalRemoveTitle')}</Modal.Title>
					</Modal.Header>
					<Modal.Body className="">
		            	{ this.state.selectedItem.cells ? (
		            		<>

								<p className="mb-0" bg="secondary">{this.props.t('drivers.modalLabelName')}</p>
		            			<b className="mb-3" bg="dark"> { this.state.selectedItem.cells[1].value + ' ' + this.state.selectedItem.cells[2].value }</b>
								<p className="mb-0" bg="secondary">{this.props.t('drivers.modalLabelDocument')}</p>
		            			<b className="mb-0" bg="dark">{ this.state.selectedItem.cells[4].value }</b>
		            		</>
		            	) : '' }
					</Modal.Body>
					<Modal.Footer>
		            	<Button 
		            		variant="danger"
		            		onClick={ this.removeDriver }
		            	>
							{this.props.t('common.remove')}
	                    </Button>
					    <Button
					    	variant="secondary" 
					    	onClick={ this.handleRemoveDriverModal }
					    >
							{this.props.t('common.close')}
					    </Button>
					</Modal.Footer>
	            </Modal>
				<Container className="px-0 py-0" fluid>
					<div className="tables-nav">
						<nav aria-label="Page navigation">
							<ul className="pagination">
								<li className="page-item">
									<a className="btn btn-outline-dark" onClick={this.prevPage}>
										<span aria-hidden="true">&laquo;</span>
										<span className="sr-only"></span>
									</a>
								</li>
								<li className="page-item"><a className="btn btn-outline-dark mx-1 font-weight-600">{this.state.currentPageNum}</a></li>
								<li className="page-item">
									<a className="btn btn-outline-dark" onClick={this.nextPage}>
										<span aria-hidden="true">&raquo;</span>
										<span className="sr-only"></span>
									</a>
								</li>
							</ul>
						</nav>
						<button 
							type="button"
							className="btn btn-outline-dark mx-1 font-weight-600"
							onClick={this.onClickAddNewItem}
						>
							<i className="bi bi-plus-circle me-2"></i>
							{this.props.t('common.add')}
						</button>
						
						
						<button 
							type="button"
							className="btn btn-outline-dark mx-1 font-weight-600"
							disabled={Object.keys(this.state.selectedItem).length === 0}
							onClick={this.editDriver}
						>
							<i className="bi bi-pencil-square me-2"></i>
							{this.props.t('common.edit')}
						</button>
						
						<button 
							type="button"
							className="btn btn-outline-dark mx-1 font-weight-600"
							disabled={Object.keys(this.state.selectedItem).length === 0}
							onClick={this.handleRemoveDriverModal}
						>
							<i className="bi bi-x-circle me-2"></i>
							{this.props.t('common.remove')}
						</button>
					</div>
					<div className="m-0 p-0">
						{content}
					</div>
				</Container>
			</>
		);
  }
}

function withMyHook(Component) {
	return function WrappedComponent(props) {
		const userData = useSelector((state) => state.currentUser.userData);
		const { t } = useTranslation()
		return <Component {...props} userData={userData} t={ t } />;
	}
}

export default withMyHook(Drivers)